export default {"src":"/_next/static/media/logo.9ad1c75b.svg","height":314,"width":327,"blurWidth":0,"blurHeight":0};